<template>
  <!-- Brand logo — swaps between per-theme light/dark logo images based on the active theme preset -->
  <div v-if="themePreset == 'dougjoneslight'" class="logo-container">
    <img src="@/assets/images/newtheme/cn_dark.svg" alt="The Change Network Logo" class="logo-image logo-hide-show" />
    <img src="@/assets/images/newtheme/cn_light.svg" alt="The Change Network Logo" class="logo-image logo-show" />
    <!-- <span class="logo-text text-[#FFF]">The Change Network</span> -->
  </div>
  <div v-if="themePreset === 'allenjackson'" class="logo-container">
    <img src="@/assets/images/newtheme/AJ_Logo_White.svg" alt="Allen Jackson Logo" class="logo-image logo-hide-show" />
    <img src="@/assets/images/newtheme/AJ_Logo_dark.svg" alt="Allen Jackson Logo" class="logo-image logo-show" />
  </div>
  <div v-if="themePreset === 'unimiddle'" class="logo-container">
    <img src="@/assets/images/newtheme/unimiddle_light.svg" alt="Unimiddle" class="logo-image logo-hide-show" />
    <img src="@/assets/images/newtheme/unimiddle_light.svg" alt="Unimiddle" class="logo-image logo-show" />
  </div>
</template>
<script setup>
/** LaunchPadLogo — renders the correct brand logo image pair for the active theme preset (light/dark variants). */
import { useThemeScheme } from "@/composables/useThemeSchema";
/** Currently unused here — light/dark image swapping is handled via CSS prefers-color-scheme instead. */
const { isDarkMode } = useThemeScheme();
import { useBranding } from "@/composables/useBranding";
/** Selects which theme's logo markup block to render. */
const { themePreset } = useBranding();

/** class — pass-through wrapper class. isDark — accepted for API parity but unused; scheme is driven by CSS media queries. */
defineProps({
  class: String,
  isDark: Boolean
});
</script>
<style scoped>
.logo-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logo-image {
  height: 94px;
  width: auto;
}
@media (prefers-color-scheme: dark) {
  .logo-show{
    display: none;
  }
}
@media (prefers-color-scheme: light) {
  .logo-hide-show{
    display: none;
  }
  .logo-text {
    /* OLD: color: #fff !important; */
    color: var(--color-white) !important;
  }
}
.logo-text {
  font-size: 24px;
  font-weight: 600;
  color: inherit;
  white-space: nowrap;
  /* OLD: color: #fff; */
  color: var(--color-white);
  /* font-family: Inter !important; */
}
</style>
